import styled from 'styled-components';

import { ds } from '@/config/colors';

export const BannerSpacing = styled.div`
  margin-bottom: 16px;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Paragraph = styled.p`
  margin: 0;
`;

export const ItemList = styled.ul`
  margin: 0;
  padding: 0 0 0 18px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  list-style: disc;
`;

export const ItemName = styled.span`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};
  overflow-wrap: anywhere;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 2px;
`;

const buttonBase = `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 16px;
  border-radius: 9999px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  text-decoration: none;
  transition: opacity 0.15s ease, background 0.15s ease;
`;

export const PrimaryLink = styled.a`
  ${buttonBase}
  border: none;
  color: ${ds.bgSurface};
  background: ${ds.accentInk};

  &:hover {
    background: ${ds.accentInkHover};
  }
`;

export const SecondaryButton = styled.button`
  ${buttonBase}
  color: ${({ theme }) => theme.colors.text.primary};
  background: ${({ theme }) => (theme.mode === 'dark' ? 'transparent' : ds.bgSurface)};
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : ds.borderDefault)};

  &:hover:not(:disabled) {
    background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255,255,255,0.04)' : ds.bgMuted)};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const InlineLink = styled.a`
  font-weight: 500;
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
  white-space: nowrap;

  &:hover {
    opacity: 0.75;
  }
`;

export const CheckResult = styled.p`
  margin: 0;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;
